import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${string | ':workOrderId'}/reviewRecap`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/reviewRecap`;

export const URL = (workOrderId: number): RouteDefinition =>
	`${baseRoute}/${workOrderId}/reviewRecap`;
